import { find } from 'lodash';

import { useQueryGetProjectVersionsList } from 'api/queries/getProjectVersionsList.query';

type Props = {
    projectId?: number | null;
    contractId?: number | null;
};

export const useGetLatestCompareToVersions = ({ projectId, contractId }: Props) => {
    const { data: versionsList, isLoading } = useQueryGetProjectVersionsList({
        projectId: projectId,
        contractId: contractId,
    });

    if (!isLoading && versionsList) {
        const latestVersion = find(versionsList, { isLatest: true });
        const compareVersion = find(versionsList, { isDesignatedBaseline: true });

        return {
            latestVersionId: latestVersion?.id,
            compareVersionId: compareVersion?.id,
        };
    }
    return {
        latestVersionId: undefined,
        compareVersionId: undefined,
    };
};